import { Component, OnInit } from '@angular/core';
import { ClientLogoService } from '../services/client-logo.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private clientLogoService: ClientLogoService) { }

  clientLogo: any;

  ngOnInit() {
    this.clientLogoService.getClientLogo()
    .subscribe(image => {
      this.clientLogo = image;
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/footer/footer.component.ts